import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomePageComponent } from './home-page/home-page.component';
import { HeaderComponent } from './header/header.component';
import { SideMenuBarComponent } from './side-menu-bar/side-menu-bar.component';
import { UserRegistrationFormComponent } from './sub-manu-page-components/customer/user-registration-form/user-registration-form.component';
import { DecimalPipe } from '@angular/common';
import { FooterComponent } from './footer/footer.component';
import { NextPreviewButtonComponent } from './components/next-preview-button/next-preview-button.component';
import { CustomerProfileComponent } from './sub-manu-page-components/customer-profile/customer-profile.component';

import { CustomerProfileTransactionalFlagComponent } from './sub-manu-page-components/customer-profile/costumer-profile-components/customer-profile-transactional-flag/customer-profile-transactional-flag.component';
import { CustomerProfileNamingConventionComponent } from './sub-manu-page-components/customer-profile/costumer-profile-components/customer-profile-naming-convention/customer-profile-naming-convention.component';
import { ConfiguratorSubMenuComponent } from './sub-menu-bar-folder/configurator-sub-menu/configurator-sub-menu.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PrimaryButtonComponent } from './tools/primary-button/primary-button.component';
import { SecondaryButtonComponent } from './tools/secondary-button/secondary-button.component';
import { BackButtonComponent } from './tools/back-button/back-button.component';
import { TextEditorComponent } from './tools/text-editor/text-editor.component';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { SwitchButtonComponent } from './tools/switch-button/switch-button.component';
import { CustomerBusinessDetailsComponent } from './sub-manu-page-components/customer-profile/costumer-profile-components/customer-business-details/customer-business-details.component';
import { CheckboxInputComponent } from './tools/checkbox-input/checkbox-input.component';
import { LoginScreenComponent } from './login-page/login-screen/login-screen.component';
import { LoginFormComponent } from './login-page/login-form/login-form.component';
import { ResetPasswordComponent } from './login-page/reset-password/reset-password.component';
import { OtpVerificationComponent } from './login-page/otp-verification/otp-verification.component';
import { CustomerConpanyProfileComponent } from './sub-manu-page-components/customer/customer-conpany-profile/customer-conpany-profile.component';
import { SearchPaymentComponent } from './sub-manu-page-components/search-payment/search-payment/search-payment.component';
import { ApiUrlService } from './shared/services/shared-services/api-url.service';
import { UserService } from './shared/services/user-services/user.service';
import { StateServicesService } from './shared/services/state-services/state-services.service';
import { CityServicesService } from './shared/services/city-services/city-services.service';
import { DistServicesService } from './shared/services/dist-services/dist-services.service';
import { ConfiguratorProviderComponent } from './sub-manu-page-components/configurator/configurator-provider/configurator-provider.component';
import { CustomerProfileContactDetailComponent } from './sub-manu-page-components/customer-profile/costumer-profile-components/customer-profile-contact-detail/customer-profile-contact-detail.component';
import { CustomerProfilePersonalDetailsComponent } from './sub-manu-page-components/customer-profile/costumer-profile-components/customer-profile-personal-details/customer-profile-personal-details.component';
import { CustomerProfileNotificationSettingComponent } from './sub-manu-page-components/customer-profile/costumer-profile-components/customer-profile-notification-setting/customer-profile-notification-setting.component';
import { EditPortalBuilderComponent } from './edit-portal-builder/edit-portal-builder.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';

// import { ActivityLogsSubMenuComponent } from './sub-menu-bar-folder/activity-logs-sub-menu/activity-logs-sub-menu/activity-logs-sub-menu.component';
import { ApiLogsComponent } from './sub-manu-page-components/activity-logs/api-logs/api-logs.component';
import { CallbackLogsComponent } from './sub-manu-page-components/activity-logs/callback-logs/callback-logs.component';
import { LoginSessionsComponent } from './sub-manu-page-components/activity-logs/login-sessions/login-sessions.component';

import { NgSelectModule } from '@ng-select/ng-select';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { PortalBuilderService } from './shared/services/administratior-service/portal-builder.service';
import { APIInterceptor } from './shared/services/shared-services/api.interceptor';
import { CustomerService } from './shared/services/customer-services/customer.service';
import { CoustomerCoustomerDataTableComponent } from './coustomer-coustomer-data-table/coustomer-coustomer-data-table.component';
import { DashboardComponent } from './sub-manu-page-components/dashboard/dashboard.component';
import { NgChartsModule } from 'ng2-charts';
import { TooltipDirective } from './common/tooltip/tooltip.directive';
import { DashboardSecondComponent } from './sub-manu-page-components/dashboard-second/dashboard-second.component';
import { ActivityLogsSubMenuComponent } from './sub-menu-bar-folder/activity-logs-sub-menu/activity-logs-sub-menu.component';
import { AnalyticsSubMenuComponent } from './sub-menu-bar-folder/analytics-sub-menu/analytics-sub-menu.component';
import { BankAnalyticsComponent } from './sub-manu-page-components/analytics/bank-analytics/bank-analytics.component';
import { ApiAnalyticsComponent } from './sub-manu-page-components/analytics/api-analytics/api-analytics.component';
import { MerchantAnalyticsComponent } from './sub-manu-page-components/analytics/merchant-analytics/merchant-analytics.component';
import { AgentAnalyticsComponent } from './sub-manu-page-components/analytics/agent-analytics/agent-analytics.component';
import { BarChartComponent } from './common/charts/bar-chart/bar-chart.component';
import { LineChartComponent } from './common/charts/line-chart/line-chart.component';
import { GeneralAnalyticsComponent } from './sub-manu-page-components/analytics/general-analytics/general-analytics.component';

import { ToastrModule } from 'ngx-toastr';
import { ToastrMsgService } from './shared/services/shared-services/toastr.service';
import { IndustryTypeService } from './shared/services/industry-type-services/industry-type.service';
import { CustomerInterfoceHomePageComponent } from './customer-interface/customer-interfoce-home-page/customer-interfoce-home-page.component';
import { ViewProfileComponent } from './sub-menu-bar-folder/view-profile/view-profile.component';
import { PersonalDetailsComponent } from './sub-manu-page-components/view-profile/personal-details/personal-details.component';
import { ContactDetailsComponent } from './sub-manu-page-components/view-profile/contact-details/contact-details.component';
import { NotificationSettingsComponent } from './sub-manu-page-components/view-profile/notification-settings/notification-settings.component';
import { PasswordManagerComponent } from './sub-manu-page-components/view-profile/password-manager/password-manager.component';
import { PinManagerComponent } from './sub-manu-page-components/view-profile/pin-manager/pin-manager.component';
import { RoleManagerComponent } from './sub-manu-page-components/view-profile/role-manager/role-manager.component';
import { MappingManagerComponent } from './sub-manu-page-components/view-profile/mapping-manager/mapping-manager.component';
import { IdentityDocumentsComponent } from './sub-manu-page-components/view-profile/identity-documents/identity-documents.component';
import { DocumentUploadPromptComponent } from './components/document-upload-prompt/document-upload-prompt.component';


import { FileUploadService } from './shared/services/shared-services/file-upload.service';
import { CustumerCustomerprofileSchememanagerComponent } from './custumer-customerprofile-schememanager/custumer-customerprofile-schememanager.component';

import { EmptyDataComponent } from './common/empty-data/empty-data.component';
import { LanguagesService } from './shared/services/languages/languages.service';
import { LoaderInterceptor } from './interceptor/loader.interceptor';
import { DelayInterceptor } from './interceptor/delay.interceptor';
import { LoaderService } from './shared/services/loader-service/loader.service';
import { LoaderComponent } from './loader/loader.component';
import { PaymentModeComponent } from './payment-mode/payment-mode.component';
import { SearchComponent } from './common/search/search.component';

import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatBadgeModule } from '@angular/material/badge';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { OsmMapComponent } from './osm-map/osm-map.component';
import { OsmMapOneComponent } from './osm-map-one/osm-map-one.component';
import { MachineRegistrationFormComponent } from './machine/machine-registration-form/machine-registration-form.component';
import { MachineButtonComponent } from './sub-menu-bar-folder/machine-button-sub-menu/machine-button.component';

import { ProjectsComponent } from './components/projects/projects.component';
import { TasksComponent } from './components/tasks/tasks.component';
import { RegisterProjectComponent } from './components/register-project/register-project.component';
import { MapEditorComponent } from './components/map-editor/map-editor.component';
import { AssetManagementComponent } from './components/admin/asset-management/asset-management.component';
import { CustomerComponent } from './sub-menu-bar-folder/customer-button-sub-menu/customer.component';
import { VendorListComponent } from './components/vendor-list/vendor-list.component';
import { AttendanceListComponent } from './attendance/attendance-list/attendance-list.component';
import { AddProjectComponent } from './components/projects/add-project/add-project.component';
import { AddOrganizationComponent } from './components/vendor-list/add-organization/add-organization.component';
import { VendorAccountsListComponent } from './components/vendor-accounts/vendor-accounts-list/vendor-accounts-list.component';
import { AddVendorAccountComponent } from './components/vendor-accounts/add-vendor-account/add-vendor-account.component';
import { VendorResourcesHubComponent } from './components/vendor-accounts/vendor-resources-hub/vendor-resources-hub.component';
import { AddServicesComponent } from './master/services/add-services/add-services.component';
import { AddMaterialAndProcessComponent } from './master/materials-and-process/add-material-and-process/add-material-and-process.component';
import { MapeditorComponent } from './mapeditor/mapeditor.component';
// import { DatePickerDirective, DpDatePickerModule } from 'ng2-date-picker';
import { MasterButtonComponent } from './sub-menu-bar-folder/master-button-sub-menu/master-button.component';
import { MaterialAndProcessListComponent } from './master/materials-and-process/material-and-process-list/material-and-process-list.component';
import { ServicesListComponent } from './master/services/services-list/services-list.component';
import { OlmComponent } from './olm/olm.component';
import { AddStaffComponent } from './components/vendor-list/add-staff/add-staff.component';
import { MachineUserRegistrationFormComponent } from './machine/machine-user-registration-form/machine-user-registration-form.component';
import { CreateLeadComponent } from './leads/create-lead/create-lead.component';
import { LeadListComponent } from './leads/lead-list/lead-list.component';
import { CreateQuotesComponent } from './quotes/create-quotes/create-quotes.component';
import { QuotesListComponent } from './quotes/quotes-list/quotes-list.component';
import { CreateContactComponent } from './contacts/create-contact/create-contact.component';
import { ContactListComponent } from './contacts/contact-list/contact-list.component';
import { CreateImportComponent } from './imports/create-import/create-import.component';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import {
  MatSlideToggleModule,
  _MatSlideToggleRequiredValidatorModule,
} from '@angular/material/slide-toggle';
import { NotificationListComponent } from './components/notification/notification-list/notification-list.component';
import { AddPortalBuilderComponent } from './components/portal-builder/add-portal-builder/add-portal-builder.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { RichTextEditorAllModule } from '@syncfusion/ej2-angular-richtexteditor';
import { MultiSelectDropdownComponent } from './shared/components/multi-select-dropdown/multi-select-dropdown.component';
import { TenderListComponent } from './components/tender/tender-list/tender-list.component';
import { CreateTenderComponent } from './components/tender/create-tender/create-tender.component';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { environment } from 'src/environments/environment';
import { RoadProjectFormComponent } from './components/projects/road-project-form/road-project-form.component';
import { MatStepperModule } from '@angular/material/stepper';
import { RoadProjectForm2Component } from './components/projects/road-project-form2/road-project-form2.component';
import { OrganizationComponent } from './components/vendor-list/organization/organization.component';
import { StaffListComponent } from './components/vendor-list/staff-list/staff-list.component';
import { OrganizationDetailsComponent } from './components/vendor-list/organization-details/organization-details.component';
import { StaffDetailsComponent } from './components/vendor-list/staff-details/staff-details.component';
import { UserDetailsComponent } from './components/vendor-list/user-details/user-details.component';
import { MatDividerModule } from '@angular/material/divider';
import { GisEditorComponent } from './components/map/gis-editor/gis-editor.component';
import { AddUserComponent } from './components/vendor-list/add-user/add-user.component';
import { AddSupportComponent } from './components/vendor-list/add-support/add-support.component';
import { CurdResourceComponent } from './master/resource/curd-resource/curd-resource.component';
import { CurdMachineResourceComponent } from './master/machine-resource/curd-machine-resource/curd-machine-resource.component';
import { CurdMaterialMasterComponent } from './master/material-master/curd-material-master/curd-material-master.component';
import { ProjectBinddingComponent } from './components/projects/project-bindding/project-bindding.component';
import { ProjectAwardComponent } from './components/projects/project-award/project-award.component';
import { SupportTicketComponent } from './components/support/support-ticket/support-ticket.component';
import { SupportTicketListComponent } from './components/support/support-ticket-list/support-ticket-list.component';
import { SupportTechnicalComponent } from './components/support/support-technical/support-technical.component';
import { MatRadioModule } from '@angular/material/radio';

import { HighchartsChartModule } from 'highcharts-angular';
import { PaymentListComponent } from './components/payment/payment-list/payment-list.component';
import { PaymentDialogComponent } from './components/payment/payment-dialog/payment-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { PackageDialogComponent, SubscriptionComponent } from './components/subscription/subscription/subscription.component';
import { UpgradeDialogComponent } from './components/subscription/upgrade-dialog/upgrade-dialog.component';
import { RenewDialogComponent } from './components/subscription/renew-dialog/renew-dialog.component';
import { SubscriptionDetailsDialogComponent } from './components/subscription/subscription-details-dialog/subscription-details-dialog.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ProgressReportComponent } from './components/progress-report/progress-report/progress-report.component';
import { ProgressReportListComponent } from './components/progress-report/progress-report-list/progress-report-list.component';
import { MonthlyBillingComponent } from './components/monthly-billing/monthly-billing/monthly-billing.component';
import { MonthlyBillingListComponent } from './components/monthly-billing/monthly-billing-list/monthly-billing-list.component';
import { ProjectClosureListComponent } from './components/project-closure/project-closure-list/project-closure-list.component';
import { ProjectClosureComponent } from './components/project-closure/project-closure/project-closure.component';
import { InvoiceFormListComponent } from './components/invoice-form/invoice-form-list/invoice-form-list.component';
import { InvoiceFormComponent } from './components/invoice-form/invoice-form/invoice-form.component';
import { ExcelImportComponent } from './components/projects/excel-import/excel-import.component';
import { AgGridModule } from 'ag-grid-angular';

import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';
import { MapeditortestComponent } from './mapeditortest/mapeditortest.component';
import { RoleListComponent } from './components/role-list/role-list.component';
import { AddRoleComponent } from './components/add-role/add-role.component';
import { ProjectDetailComponent } from './components/projects/project-detail/project-detail.component';
import { ProjectChangeHistoryComponent } from './components/projects/project-change-history/project-change-history.component';
import { ConstructionDocumentChecklistComponent } from './components/projects/construction-document-checklist/construction-document-checklist.component';

import { OnboardingComponent } from './onboarding/onboarding.component';
import { SignupFormComponent } from './onboarding/Signup-form/signup-form.component';
import { CompanyInfoComponent } from './onboarding/company-info/company-info.component';
import { EmailVerificationComponent } from './onboarding/otp-verification/otp-verification.component';

import { PackageListComponent } from './components/packages/package-list/package-list.component';
import { PackageFormComponent } from './components/packages/package-form/package-form.component';
import { NgxEditorModule } from "ngx-editor";
import { MultiOrganizationComponent } from './components/vendor-list/multi-organization/multi-organization.component';
import { RegisterComponent } from './onboarding/register/register.component';
import { SuccessPaymentComponent } from './components/payment/success-payment/success-payment.component';
import { FailurePaymentComponent } from './components/payment/failure-payment/failure-payment.component';
import { AddMultiProjectComponent } from './components/projects/add-multi-project/add-multi-project.component';
import { AddDocProjectComponent } from './components/projects/add-doc-project/add-doc-project.component';
import { DocumentDialogComponent } from './components/projects/document-dialog/document-dialog.component';
import { AddUserProjectComponent } from './components/projects/add-user-project/add-user-project.component';
import { ProjectStaffAllocationComponent } from './components/projects/project-staff-allocation/project-staff-allocation.component';
import { UserDialogComponent } from './components/projects/user-dialog/user-dialog.component';
import { AddWorkProjectComponent } from './components/projects/add-work-project/add-work-project.component';
import { WorkDialogComponent } from './components/projects/work-dialog/work-dialog.component';
import { ImageViewDialogComponent } from './components/projects/image-view-dialog/image-view-dialog.component';
import { BranchListComponent } from './components/vendor-list/branch-list/branch-list.component';
import { AddBranchComponent } from './components/vendor-list/add-branch/add-branch.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { EditBranchComponent } from './components/vendor-list/edit-branch/edit-branch.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import {MatTabsModule} from '@angular/material/tabs';
import { PlacePickerComponent } from './place-picker/place-picker.component';
import { MaterialCostComponent } from './components/projects/material-cost/material-cost.component';
import { MultiMachineRegistrationFormComponent } from './machine/multi-machine-registration-form/multi-machine-registration-form.component';
import { AddNewOrganizationComponent } from './components/vendor-list/add-new-organization/add-new-organization.component';
import { InvitedOrgsStatsComponent } from './components/vendor-list/invited-orgs-stats/invited-orgs-stats.component';
import { AddConstructionMaterialsComponent } from './components/vendor-list/add-construction-materials/add-construction-materials.component';
import { ConstructionMaterialsListComponent } from './components/vendor-list/construction-materials-list/construction-materials-list.component';
import { AddMachineComponent } from './machine/add-machine/add-machine.component';
import { MachineMasterComponent } from './machine/machine-master/machine-master.component';
import { AddMachineMasterComponent } from './machine/add-machine-master/add-machine-master.component';
import { CrewMachineMatrixComponent } from './machine/crew-machine-matrix/crew-machine-matrix.component';
import { MachineReservationListComponent } from './machine/machine-reservation-list/machine-reservation-list.component';
import { MachineReservationFormDialogComponent } from './machine/machine-reservation-form-dialog/machine-reservation-form-dialog.component';
import { ProjectMachineAvailabilityComponent } from './components/projects/project-machine-availability/project-machine-availability.component';
import { VendorRankingDashboardComponent } from './components/vendor-ranking/vendor-ranking-dashboard/vendor-ranking-dashboard.component';
import { GisBoqGenerateDialogComponent } from './components/boq/gis-boq-generate-dialog/gis-boq-generate-dialog.component';
import { MaterialMasterComponent } from './components/projects/material-master/material-master.component';
import { BiddingComponent } from './components/projects/bidding/bidding.component';
import { ConfirmDeleteDialogComponent } from './shared/confirm-delete-dialog/confirm-delete-dialog.component';
import { VendorOffboardDialogComponent } from './shared/vendor-offboard-dialog/vendor-offboard-dialog.component';
import { SurveyApprovalDialogComponent } from './shared/survey-approval-dialog/survey-approval-dialog.component';
import { DesignStageListComponent } from './components/projects/design-stage/design-stage-list/design-stage-list.component';
import { AddDesignStageComponent } from './components/projects/design-stage/add-design-stage/add-design-stage.component';
import { AddPlanningComponent } from './components/projects/planning/add-planning/add-planning.component';
import { PlanningListComponent } from './components/projects/planning/planning-list/planning-list.component';
import { SubscriptionCalculatorComponent } from './subscriptionManager/subscription/subscription.component';
import { NewProjectListComponent } from './components/projects/new-project-list/new-project-list.component';
import { AddNewProjectComponent } from './components/projects/add-new-project/add-new-project.component';
import { AddEstimationStageComponent } from './components/projects/estimation-stage/add-estimation-stage/add-estimation-stage.component';
import { EstimationStageListComponent } from './components/projects/estimation-stage/estimation-stage-list/estimation-stage-list.component';
import { AddInspectionStageComponent } from './components/projects/inspection-stage/add-inspection-stage/add-inspection-stage.component';
import { InspectionStageListComponent } from './components/projects/inspection-stage/inspection-stage-list/inspection-stage-list.component';
import { SegmentInspectionListComponent } from './components/projects/segment-inspection/segment-inspection-list/segment-inspection-list.component';
import { SegmentInspectionFormComponent } from './components/projects/segment-inspection/segment-inspection-form/segment-inspection-form.component';
import { SegmentInspectionDetailComponent } from './components/projects/segment-inspection/segment-inspection-detail/segment-inspection-detail.component';
import { PlmPavementProgressComponent } from './components/plm/plm-pavement-progress/plm-pavement-progress.component';
import { PlmResourceMapComponent } from './components/plm/plm-resource-map/plm-resource-map.component';
import { PlmClosureComponent } from './components/plm/plm-closure/plm-closure.component';
import { PlmOpsComponent } from './components/plm/plm-ops/plm-ops.component';
import { ConfirmStageDialogComponent } from './shared/confirm-stage-dialog/confirm-stage-dialog.component';
import { DomainSelectionComponent } from './subscriptionManager/domain-selection/domain-selection.component';
import { DocomentListComponent } from './components/projects/docoment/docoment-list/docoment-list.component';
import { AddB1Component } from './components/projects/B1/add-b1/add-b1.component';
import { AddB2Component } from './components/projects/B2/add-b2/add-b2.component';
import { NewOrganizationComponent } from './components/vendor-list/organization/new-organization/new-organization.component';
import { AddMiningPlanComponent } from './components/projects/mining-plan/add-mining-plan/add-mining-plan.component';
import { B1ListComponent } from './components/projects/B1/b1-list/b1-list.component';
import { B2ListComponent } from './components/projects/B2/b2-list/b2-list.component';
import { BiddingListComponent } from './components/projects/bidding/bidding-list/bidding-list.component';
import { AddBiddingComponent } from './components/projects/bidding/add-bidding/add-bidding.component';
import { AddClosureComponent } from './components/projects/closure/add-closure/add-closure.component';
import { ClosureListComponent } from './components/projects/closure/closure-list/closure-list.component';
import { DeviationsReportListComponent } from './components/projects/deviations-report/deviations-report-list/deviations-report-list.component';
import { AddDeviationsReportComponent } from './components/projects/deviations-report/add-deviations-report/add-deviations-report.component';
import { AddExecutionComponent } from './components/projects/execution/add-execution/add-execution.component';
import { ExecutionListComponent } from './components/projects/execution/execution-list/execution-list.component';
import { AddInvoiceComponent } from './components/projects/invoice/add-invoice/add-invoice.component';
import { InvoiceListComponent } from './components/projects/invoice/invoice-list/invoice-list.component';
import { MonitoringListComponent } from './components/projects/monitoring/monitoring-list/monitoring-list.component';
import { AddMonitoringComponent } from './components/projects/monitoring/add-monitoring/add-monitoring.component';
import { PoAmendmentFormListComponent } from './components/projects/po-amendment-form/po-amendment-form-list/po-amendment-form-list.component';
import { AddPoAmendmentFormComponent } from './components/projects/po-amendment-form/add-po-amendment-form/add-po-amendment-form.component';
import { AddPurchaseOrderComponent } from './components/projects/purchase-order/add-purchase-order/add-purchase-order.component';
import { PurchaseOrderListComponent } from './components/projects/purchase-order/purchase-order-list/purchase-order-list.component';
import { WorkOrderListComponent } from './components/work-orders/work-order-list/work-order-list.component';
import { WorkOrderFormComponent } from './components/work-orders/work-order-form/work-order-form.component';
import { WorkOrderViewComponent } from './components/work-orders/work-order-view/work-order-view.component';
import { AddSIVComponent } from './components/projects/SIV/add-siv/add-siv.component';
import { SIVListComponent } from './components/projects/SIV/siv-list/siv-list.component';
import { AddSRVComponent } from './components/projects/SRV/add-srv/add-srv.component';
import { SRVListComponent } from './components/projects/SRV/srv-list/srv-list.component';
import { AddSurveyComponent } from './components/projects/survey/add-survey/add-survey.component';
import { SurveyListComponent } from './components/projects/survey/survey-list/survey-list.component';
import { AddAwardComponent } from './components/projects/award/add-award/add-award.component';
import { BomListComponent } from './bom-list/bom-list.component';
import { BomComponent } from './bom/bom.component';
import { AiBomComponent } from './components/ai-bom/ai-bom.component';
import { AiBoqComponent } from './components/ai-boq/ai-boq.component';
import { ApprovalWorkflowComponent } from './approval-workflow/approval-workflow.component';
import { WorkLogComponent } from './work-log/work-log.component';
import { RoadProjectComponent } from './road-project/road-project.component';
import { DailyReportsListComponent } from './labour-mobilization/daily-reports-list/daily-reports-list.component';
import { DailyReportFormComponent } from './labour-mobilization/daily-report-form/daily-report-form.component';
import { MobilizationPlansListComponent } from './labour-mobilization/mobilization-plans-list/mobilization-plans-list.component';
import { MobilizationPlanFormComponent } from './labour-mobilization/mobilization-plan-form/mobilization-plan-form.component';
import { DeviationReportComponent } from './labour-mobilization/deviation-report/deviation-report.component';
import { ClientListComponent } from './client-list/client-list.component';
import { EditClientComponent } from './client-list/edit-client/edit-client.component';
import { AwardListComponent } from './components/projects/award/award-list/award-list.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { PurchasePlanComponent } from './purchase-plan/purchase-plan.component';
import { GismapeditorComponent } from './gismapeditor/gismapeditor.component';
import { OrgOrganizationComponent } from './components/vendor-list/org-organization/org-organization.component';
import { CadviewerComponent } from './cadviewer/cadviewer.component';
import { ClickupIntegrationComponent } from './components/integrations/clickup/clickup-integration.component';
import { IntegrationsHubComponent } from './components/integrations/integrations-hub/integrations-hub.component';
import { GeospatialDashboardComponent } from './components/geospatial/geospatial-dashboard/geospatial-dashboard.component';
import { IntegrationSetupComponent } from './components/integrations/integration-setup/integration-setup.component';
import { WorkBreakdownStructureComponent } from './components/work-breakdown-structure/work-breakdown-structure.component';
import { WBSDeviationReportComponent } from './components/work-breakdown-structure/wbs-deviation-report/wbs-deviation-report.component';
import { WbsProjectListComponent } from './components/work-breakdown-structure/wbs-project-list/wbs-project-list.component';
import { BoqListComponent } from './components/boq/boq-list/boq-list.component';
import { BoqFormComponent } from './components/boq/boq-form/boq-form.component';
import { SendForBiddingDialogComponent } from './components/boq/send-for-bidding-dialog/send-for-bidding-dialog.component';
import { BiddingLinkDialogComponent } from './components/boq/bidding-link-dialog/bidding-link-dialog.component';
import { ViewBidsDialogComponent } from './components/boq/view-bids-dialog/view-bids-dialog.component';
import { BiddingDeviationReportDialogComponent } from './components/boq/bidding-deviation-report-dialog/bidding-deviation-report-dialog.component';
import { AwardBiddersDialogComponent } from './components/boq/award-bidders-dialog/award-bidders-dialog.component';
import { ExtendBidClosingDialogComponent } from './components/boq/extend-bid-closing-dialog/extend-bid-closing-dialog.component';
import { CloseBidDialogComponent } from './components/boq/close-bid-dialog/close-bid-dialog.component';
import { ViewBidsPageComponent } from './components/boq/view-bids-page/view-bids-page.component';
import { BiddingDeviationReportPageComponent } from './components/boq/bidding-deviation-report-page/bidding-deviation-report-page.component';
import { BoqPlannedActualDeviationComponent } from './components/boq/boq-planned-actual-deviation/boq-planned-actual-deviation.component';
import { InvitationsListDialogComponent } from './components/boq/invitations-list-dialog/invitations-list-dialog.component';
import { BoqBiddingInviteComponent } from './components/boq/boq-bidding-invite/boq-bidding-invite.component';
import { BoqBiddingWrapperComponent } from './components/boq/boq-bidding-wrapper/boq-bidding-wrapper.component';
import { AlertListComponent } from './components/alerts/alert-list/alert-list.component';
import { OrganizationSwitchComponent } from './components/organization-switch/organization-switch.component';
import { ProjectBillsComponent } from './components/project-bills/project-bills.component';
import { BillDetailsDialogComponent } from './components/project-bills/bill-details-dialog/bill-details-dialog.component';
import { EditBillAmountDialogComponent } from './components/project-bills/edit-bill-amount-dialog/edit-bill-amount-dialog.component';
import { DocumentViewerComponent } from './components/documents/document-viewer/document-viewer.component';
import { DocumentUploadComponent } from './components/documents/document-upload/document-upload.component';
import { DocumentListComponent } from './components/documents/document-list/document-list.component';
import { RoadBoQListComponent } from './components/road-boq/road-boq-list/road-boq-list.component';
import { RoadBoqFormComponent } from './components/road-boq/road-boq-form/road-boq-form.component';
ModuleRegistry.registerModules([AllCommunityModule]);
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    HomePageComponent,
    HeaderComponent,
    SideMenuBarComponent,
    UserRegistrationFormComponent,
    CustomerComponent,
    FooterComponent,
    NextPreviewButtonComponent,
    CustomerProfileComponent,
    CustomerProfileTransactionalFlagComponent,
    CustomerProfileNamingConventionComponent,
    ConfiguratorSubMenuComponent,
    PrimaryButtonComponent,
    SecondaryButtonComponent,
    BackButtonComponent,
    TextEditorComponent,
    SwitchButtonComponent,
    CustomerBusinessDetailsComponent,

    CheckboxInputComponent,
    LoginScreenComponent,
    LoginFormComponent,
    SignupFormComponent,
    ResetPasswordComponent,
    OtpVerificationComponent,
    CustomerConpanyProfileComponent,
    CreateContactComponent,
    CreateLeadComponent,
    SearchPaymentComponent,
    ActivityLogsSubMenuComponent,
    ApiLogsComponent,
    LoginSessionsComponent,
    CallbackLogsComponent,
    ConfiguratorProviderComponent,
    CustomerProfileContactDetailComponent,
    CustomerProfilePersonalDetailsComponent,
    CustomerProfileNotificationSettingComponent,
    EditPortalBuilderComponent,
    ForgotPasswordComponent,
    CoustomerCoustomerDataTableComponent,
    DashboardComponent,
    TooltipDirective,
    DashboardSecondComponent,

    AnalyticsSubMenuComponent,
    BankAnalyticsComponent,
    ApiAnalyticsComponent,
    MerchantAnalyticsComponent,
    GeneralAnalyticsComponent,
    AgentAnalyticsComponent,
    BarChartComponent,
    LineChartComponent,
    CustomerInterfoceHomePageComponent,

    ViewProfileComponent,
    PersonalDetailsComponent,
    ContactDetailsComponent,
    NotificationSettingsComponent,
    PasswordManagerComponent,
    PinManagerComponent,
    RoleManagerComponent,
    MappingManagerComponent,
    IdentityDocumentsComponent,
    DocumentUploadPromptComponent,
    DocumentViewerComponent,DocumentUploadComponent,
    CustumerCustomerprofileSchememanagerComponent,DocumentListComponent,
    RoadBoQListComponent,
    RoadBoqFormComponent,
    LoaderComponent,
    EmptyDataComponent,
ConfirmDeleteDialogComponent,
    VendorOffboardDialogComponent,
    SurveyApprovalDialogComponent,
    PaymentModeComponent,
    SearchComponent,
    OsmMapComponent,
    OsmMapOneComponent,
    MachineRegistrationFormComponent,
    MachineButtonComponent,
    ProjectsComponent,
    TasksComponent,
    RegisterProjectComponent,
    MapEditorComponent,
    AssetManagementComponent,
    VendorListComponent,
    AttendanceListComponent,
    AddProjectComponent,
    AddOrganizationComponent,
    VendorAccountsListComponent,
    AddVendorAccountComponent,
    VendorResourcesHubComponent,
    AddServicesComponent,
    AddMaterialAndProcessComponent,
    MasterButtonComponent,
    MaterialAndProcessListComponent,
    ServicesListComponent,
    MapeditorComponent,
    OlmComponent,
    MapeditorComponent,
    AddStaffComponent,
    MachineUserRegistrationFormComponent,
    LeadListComponent,
    CreateQuotesComponent,
    QuotesListComponent,
    ContactListComponent,
    CreateImportComponent,
    NotificationListComponent,
    AddPortalBuilderComponent,
    MultiSelectDropdownComponent,
    TenderListComponent,
    CreateTenderComponent,
    RoadProjectFormComponent,
    RoadProjectForm2Component,
    OrganizationComponent,
    StaffListComponent,
    OrganizationDetailsComponent,
    StaffDetailsComponent,
    UserDetailsComponent,
    GisEditorComponent,
    AddUserComponent,
    AddSupportComponent,
    CurdResourceComponent,
    CurdMachineResourceComponent,
    CurdMaterialMasterComponent,
    ProjectBinddingComponent,
    ProjectAwardComponent,
    SupportTicketComponent,
    SupportTicketListComponent,
    SupportTechnicalComponent,
    PaymentListComponent,
    PaymentDialogComponent,
    SubscriptionComponent,
    ProgressReportComponent,
    ProgressReportListComponent,
    MonthlyBillingComponent,
    MonthlyBillingListComponent,
    ProjectClosureListComponent,
    ProjectClosureComponent,
    InvoiceFormListComponent,
    InvoiceFormComponent,
    ProjectBillsComponent,
    BillDetailsDialogComponent,
    EditBillAmountDialogComponent,
    ExcelImportComponent,
    MapeditortestComponent,
    RoleListComponent,
    AddRoleComponent,
    ProjectDetailComponent,
    ProjectChangeHistoryComponent,
    OnboardingComponent, CompanyInfoComponent,
    EmailVerificationComponent,PackageFormComponent,
    PackageListComponent,
    MultiOrganizationComponent,
    RegisterComponent,
    SuccessPaymentComponent,
    FailurePaymentComponent,
    PackageDialogComponent,
    UpgradeDialogComponent,
    RenewDialogComponent,
    SubscriptionDetailsDialogComponent,
    FailurePaymentComponent,
    AddMultiProjectComponent,
    AddDocProjectComponent,
    DocumentDialogComponent,
    AddUserProjectComponent,
    ProjectStaffAllocationComponent,
    UserDialogComponent,
    AddWorkProjectComponent,
    WorkDialogComponent,
    ImageViewDialogComponent,
    BranchListComponent,
    AddBranchComponent,
    EditBranchComponent,
    PlacePickerComponent,
    MaterialCostComponent,
    MultiMachineRegistrationFormComponent,
    AddNewOrganizationComponent,
    InvitedOrgsStatsComponent,
    AddConstructionMaterialsComponent,
    ConstructionMaterialsListComponent,
    AddMachineComponent,
    MachineMasterComponent,
    AddMachineMasterComponent,
    CrewMachineMatrixComponent,
    MachineReservationListComponent,
    MachineReservationFormDialogComponent,
    ProjectMachineAvailabilityComponent,
    VendorRankingDashboardComponent,
    GisBoqGenerateDialogComponent,
    MaterialMasterComponent,
    BiddingComponent,
    DesignStageListComponent,
    AddDesignStageComponent,
    AddPlanningComponent,
    PlanningListComponent,
    SubscriptionCalculatorComponent,
    PlanningListComponent,
    NewProjectListComponent,
    AddNewProjectComponent,
    AddEstimationStageComponent,
    EstimationStageListComponent,
    AddInspectionStageComponent,
    InspectionStageListComponent,
    SegmentInspectionListComponent,
    SegmentInspectionFormComponent,
    SegmentInspectionDetailComponent,
    PlmPavementProgressComponent,
    PlmResourceMapComponent,
    PlmClosureComponent,
    PlmOpsComponent,
    ConfirmStageDialogComponent,
    DomainSelectionComponent,
    ProjectDetailComponent,
    ProjectChangeHistoryComponent,
    ConstructionDocumentChecklistComponent,
    DocomentListComponent,
    AddB1Component,
    AddB2Component,
    NewOrganizationComponent,
    AddMiningPlanComponent,
    B1ListComponent,
    B2ListComponent,
    BiddingListComponent,
    AddBiddingComponent,
    AddClosureComponent,
    ClosureListComponent,
    DeviationsReportListComponent,
    AddDeviationsReportComponent,
    AddExecutionComponent,
    ExecutionListComponent,
    AddInvoiceComponent,
    InvoiceListComponent,
    MonitoringListComponent,
    AddMonitoringComponent,
    PoAmendmentFormListComponent,
    AddPoAmendmentFormComponent,
    AddPurchaseOrderComponent,
    PurchaseOrderListComponent,
    WorkOrderListComponent,
    WorkOrderFormComponent,
    WorkOrderViewComponent,
    AddSIVComponent,
    SIVListComponent,
    AddSRVComponent,
    SRVListComponent,
    AddSurveyComponent,
    SurveyListComponent,
    AddAwardComponent,
    BomListComponent,
    BomComponent,
    AiBomComponent,
    AiBoqComponent,
    ApprovalWorkflowComponent,
    WorkLogComponent,
    RoadProjectComponent,
    ClientListComponent,
    EditClientComponent,
    DailyReportsListComponent,
    DailyReportFormComponent,
    MobilizationPlansListComponent,
    MobilizationPlanFormComponent,
    DeviationReportComponent,
    AwardListComponent,
    ContactUsComponent,
    PurchasePlanComponent,
    OrgOrganizationComponent,CadviewerComponent,
    ClickupIntegrationComponent,
    IntegrationsHubComponent,
    GeospatialDashboardComponent,
    IntegrationSetupComponent,
    WorkBreakdownStructureComponent,
    WBSDeviationReportComponent,
    WbsProjectListComponent,
    BoqListComponent,
    BoqFormComponent,
    SendForBiddingDialogComponent,
    BiddingLinkDialogComponent,
    ViewBidsDialogComponent,
    BiddingDeviationReportDialogComponent,
    AwardBiddersDialogComponent,
    ExtendBidClosingDialogComponent,
    CloseBidDialogComponent,
    ViewBidsPageComponent,
    BiddingDeviationReportPageComponent,
    BoqPlannedActualDeviationComponent,
    InvitationsListDialogComponent,
    BoqBiddingInviteComponent,
    BoqBiddingWrapperComponent,
    AlertListComponent,
    OrganizationSwitchComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,  
    BrowserAnimationsModule,
    FormsModule,
    AngularEditorModule,
    ToastrModule.forRoot(),
    ToastrModule,
    HttpClientModule,
    NgChartsModule,
    
    NgSelectModule,
    MatButtonModule,
    MatInputModule,
    MatMenuModule,
    MatBadgeModule,
    MatProgressSpinnerModule,
    LeafletModule,
    // DpDatePickerModule,
    MatFormFieldModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCardModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatIconModule,
    MatCheckboxModule,
    MatExpansionModule,
    NgxSpinnerModule, MatSlideToggleModule,
    _MatSlideToggleRequiredValidatorModule,
    MatButtonModule,
    MatAutocompleteModule,
    // Registering EJ2 Rich Text Editor Module
    RichTextEditorAllModule,
    MatStepperModule,
    MatDividerModule,
    MatRadioModule, HighchartsChartModule,
    MatRadioModule,
    MatDialogModule,
    MatButtonToggleModule,
    MatTooltipModule ,
    NgbModule,
    MatTabsModule,
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    // TranslateModule,
    AgGridModule,
    NgxEditorModule,
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideAuth(() => getAuth())
  ],
  providers: [
    DecimalPipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: APIInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true
    },
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: DelayInterceptor,
    //   multi: true
    // },
    ApiUrlService,
    UserService,
    CustomerService,
    StateServicesService,
    CityServicesService,
    
    LanguagesService,
    DistServicesService,
    ToastrMsgService,
    IndustryTypeService,
    PortalBuilderService,
    FileUploadService,
    LoaderService,

  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule { }
